export default __webpack_public_path__ + "static/misskey_logo-98fb7709bfeb247b96b12934f08497f9.png";